"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

document.addEventListener('DOMContentLoaded', function () {
  var productDataContainer = document.getElementById('ProductData');

  if (!productDataContainer) {
    return;
  }

  var parsedData = JSON.parse(productDataContainer.innerHTML);
  var mealsWrapper = document.querySelector('[data-meals-container]');
  axios({
    method: 'GET',
    url: "https://".concat(window.Shopify.shop, "/collections/").concat(parsedData.bundleCollection, "?view=bundle-json"),
    responseType: 'JSON'
  }).then(function (response) {
    var allProducts = response.data.products;
    parsedData.products = allProducts;
    var mealTypes = parsedData.productTypes;
    var html = '<div class="meals"><ul class="accordion">';

    var _loop = function _loop(i) {
      if (i === 0) {
        html += "<li class=\"accordion__item accordion__item--active meal\" data-meal-type=\"".concat(mealTypes[i], "\">") + "<div class=\"accordion__header\"><span class=\"meal__title\">".concat(i + 1, ". ").concat(mealTypes[i], "</span><p class=\"meal__count-container\"><span class=\"meal__count\">0</span> selected</p><p class=\"meal__completed\">") + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><circle cx="12" cy="12" r="12" fill="#FFDB30"/><path fill="#000" d="M15.2121936,8.38419863 C15.5523158,7.9490718 16.1807793,7.87205531 16.6159061,8.21217748 C17.0510329,8.55229966 17.1280494,9.18076314 16.7879272,9.61588997 L12.305394,15.3505072 C11.9705438,15.7788894 11.3547735,15.8612258 10.9191384,15.5358674 L7.40167168,12.9088119 C6.95917787,12.5783309 6.86837352,11.951711 7.19885449,11.5092172 C7.52933546,11.0667234 8.15595533,10.975919 8.59844914,11.3064 L11.3321222,13.3480713 L15.2121936,8.38419863 Z"/></g></svg></p>' + '<div class="meal__progress"></div></div>';
      } else {
        html += "<li class=\"accordion__item meal\" data-meal-type=\"".concat(mealTypes[i], "\">") + "<div class=\"accordion__header\"><span class=\"meal__title\">".concat(i + 1, ". ").concat(mealTypes[i], "</span><p class=\"meal__count-container\"><span class=\"meal__count\">0</span> selected</p><p class=\"meal__completed\">") + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><circle cx="12" cy="12" r="12" fill="#FFDB30"/><path fill="#000" d="M15.2121936,8.38419863 C15.5523158,7.9490718 16.1807793,7.87205531 16.6159061,8.21217748 C17.0510329,8.55229966 17.1280494,9.18076314 16.7879272,9.61588997 L12.305394,15.3505072 C11.9705438,15.7788894 11.3547735,15.8612258 10.9191384,15.5358674 L7.40167168,12.9088119 C6.95917787,12.5783309 6.86837352,11.951711 7.19885449,11.5092172 C7.52933546,11.0667234 8.15595533,10.975919 8.59844914,11.3064 L11.3321222,13.3480713 L15.2121936,8.38419863 Z"/></g></svg></p>' + '<div class="meal__progress"></div></div>';
      }

      html += "<div class=\"accordion__content\"><div class=\"meal__items meal__items--".concat(mealTypes[i], "\" data-meal-type=\"").concat(mealTypes[i], "\">");
      var mealProducts = allProducts.filter(function (product) {
        return product.tags.indexOf(mealTypes[i]) > -1;
      });

      for (var j = 0; j < mealProducts.length; j += 1) {
        var buttonAvailable = "\n          <button class=\"meal__button meal__button--add\" data-meal-id=\"".concat(mealProducts[j].id, "\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"9\" viewBox=\"0 0 9 9\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M4,1 C4,0.723857625 4.22385763,0.5 4.5,0.5 C4.77614237,0.5 5,0.723857625 5,1 L5,8 C5,8.27614237 4.77614237,8.5 4.5,8.5 C4.22385763,8.5 4,8.27614237 4,8 L4,1 Z\"/><path d=\"M8,5 L1,5 C0.333333333,5 0.333333333,4 1,4 L8,4 C8.66666667,4 8.66666667,5 8,5 Z\"/></g></svg> Add\n          </button>\n          ");
        var buttonUnavailable = "\n          <button disabled data-unavailable class=\"meal__button meal__button--add\" data-meal-id=\"".concat(mealProducts[j].id, "\">\n            Unavailable\n          </button>\n          ");
        html += "\n          <div class=\"meal__card\" data-meal-id=\"".concat(mealProducts[j].id, "\" data-meal-type=\"").concat(mealTypes[i], "\">\n            <div class=\"meal__details\">\n              <button class=\"meal__information\" data-meal-id=\"").concat(mealProducts[j].id, "\">i</button>\n              <img class=\"meal__image\" src=\"").concat(mealProducts[j].featured_image, "\" alt=\"").concat(mealProducts[j].title, "\"/>\n              <div class=\"meal__quantity-changer\">\n                <button class=\"meal__button meal__button--minus\" data-meal-id=\"").concat(mealProducts[j].id, "\">\n                  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"1\" viewBox=\"0 0 8 1\"><path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M7.5,12 L0.5,12 C-0.166666667,12 -0.166666667,11 0.5,11 L7.5,11 C8.16666667,11 8.16666667,12 7.5,12 Z\" transform=\"translate(0 -11)\"/></svg>\n                </button>\n                <span class=\"meal__quantity\">0</span>\n                <button class=\"meal__button meal__button--plus\" data-meal-id=\"").concat(mealProducts[j].id, "\">\n                  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"9\" viewBox=\"0 0 9 9\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M4,1 C4,0.723857625 4.22385763,0.5 4.5,0.5 C4.77614237,0.5 5,0.723857625 5,1 L5,8 C5,8.27614237 4.77614237,8.5 4.5,8.5 C4.22385763,8.5 4,8.27614237 4,8 L4,1 Z\"/><path d=\"M8,5 L1,5 C0.333333333,5 0.333333333,4 1,4 L8,4 C8.66666667,4 8.66666667,5 8,5 Z\"/></g></svg>\n                </button>\n              </div>\n              ").concat(mealProducts[j].available ? buttonAvailable : buttonUnavailable, "\n            </div>\n            <p>").concat(mealProducts[j].title, "</p>\n          </div>\n          ");
      }

      html += "".concat('</div><div class="slider__controls"><span class="prev" data-controls="prev">' + '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#5A5755" fill-rule="evenodd" d="M7.84575862,6.20938481 C8.11200862,5.94311436 8.11200862,5.51141299 7.84575862,5.24514595 C7.57950862,4.97887952 7.14778135,4.97887952 6.88153135,5.24514595 L3.2727359,8.85393936 L-0.336052739,5.24514595 C-0.602323193,4.97887952 -1.03402524,4.97887952 -1.3002916,5.24514595 C-1.56655831,5.51141299 -1.56655831,5.94311436 -1.3002916,6.20938481 L2.79061544,10.3002939 C3.0568859,10.5665575 3.4885859,10.5665575 3.75485635,10.3002939 L7.84575862,6.20938481 Z" transform="rotate(90 4.773 6.273)"/></svg>' + '</span><span class="next" data-controls="next">' + '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#5A5755" fill-rule="evenodd" d="M76.1639387,12.3457503 C75.8976682,12.6120003 75.4659669,12.6120003 75.1996998,12.3457503 C74.9334334,12.0795003 74.9334334,11.647773 75.1996998,11.381523 L78.8084932,7.77272753 L75.1996998,4.16393889 C74.9334334,3.89766844 74.9334334,3.46596639 75.1996998,3.19970003 C75.4659669,2.93343332 75.8976682,2.93343332 76.1639387,3.19970003 L80.2548478,7.29060707 C80.5211114,7.55687753 80.5211114,7.98857753 80.2548478,8.25484798 L76.1639387,12.3457503 Z" transform="translate(-75 -3)"/></svg>' + '</span><p class="slider__information"><span class="currentSlide">1</span> of <span class="totalSlides">').concat(mealProducts.length, "</span></p></div></div></li>");
    };

    for (var i = 0; i < mealTypes.length; i += 1) {
      _loop(i);
    }

    html += '</ul></div>';

    if (mealsWrapper) {
      mealsWrapper.innerHTML = html;
    } // Initialise data containers


    var subscriptionProductDataContainer = document.getElementById('SubscriptionProductData');
    var subscriptionProductData = {};
    var productData = {};
    var productTypes = [];
    var maxProducts = {};
    var subscriptionData = {};
    var totalMealCount = 0;
    var maxMealCount = parsedData.maxMealCount; // Initialise DOM Element variables

    var accordion = document.querySelector('.accordion');
    var accordionItems = accordion.querySelectorAll('.accordion__header');
    var mealItems = document.querySelectorAll('.meal__items');
    var mealCards = document.querySelectorAll('.meal__card');
    var mealPopup = document.querySelector('.meal-popup');
    var addToCartForm = document.querySelector('#AddToCart');
    var addToCartButton = document.querySelector('#AddToCartButton');
    var subscriptionSelector = document.getElementById('SubscriptionFrequency');
    var subscriptionInput;

    if (addToCartForm) {
      subscriptionInput = addToCartForm.querySelector('[data-product-id]');
    }

    var virtualCart = [];
    var sliders = {};

    var createSlider = function createSlider(container, mealType) {
      var controls = container.parentNode.querySelector('.slider__controls');
      var pageCount = 0;
      var sliderOptions = {
        items: 1,
        edgePadding: 10,
        slideBy: 'page',
        gutter: 20,
        loop: false,
        fixedWidth: 255,
        rewind: true,
        center: true,
        controlsPosition: true,
        nav: false,
        onInit: function onInit(slideInfo) {
          pageCount = Math.ceil(slideInfo.slideCount / slideInfo.slideBy);
          var currPage = 1;
          controls.querySelector('.slider__information .currentSlide').textContent = currPage;
          controls.querySelector('.slider__information .totalSlides').textContent = pageCount;
        },
        responsive: {
          480: {
            items: 2,
            fixedWidth: false
          },
          768: {
            items: 3,
            center: false,
            slideBy: 'page',
            fixedWidth: false,
            mouseDrag: true
          },
          1100: {
            items: 4,
            center: false,
            slideBy: 'page',
            fixedWidth: false,
            edgePadding: 0,
            mouseDrag: true
          }
        }
      };

      var newSliderOptions = _objectSpread({}, sliderOptions, {
        container: container,
        controlsContainer: controls
      });

      sliders[mealType] = new window.tns(newSliderOptions);
      sliders[mealType].events.on('transitionEnd', function (evt) {
        controls.querySelector('.slider__information .currentSlide').textContent = Math.ceil((evt.index + evt.slideBy) / evt.slideBy);
      });
    }; // Check if the data container exists


    if (productDataContainer) {
      productData = parsedData.products;
      productTypes = parsedData.productTypes;
      maxProducts = parsedData.maxProducts;
      subscriptionData = parsedData.subscription;
    } // Check if the subscription data exists


    if (subscriptionProductDataContainer) {
      subscriptionProductData = JSON.parse(subscriptionProductDataContainer.innerHTML);
    }

    if (mealItems) {
      mealItems.forEach(function (mealItem) {
        createSlider(mealItem, mealItem.dataset.mealType);
      });
    }

    var findProduct = function findProduct(productId) {
      return productData.find(function (product) {
        return product.id === parseInt(productId, 10);
      });
    };

    var buildPopup = function buildPopup(product) {
      var popupTitle = mealPopup.querySelector('.meal-popup__title');
      var popupSubtitle = mealPopup.querySelector('.meal-popup__subtitle');
      var popupDescription = mealPopup.querySelector('[data-tab="description"]');
      var popupNutrition = mealPopup.querySelector('[data-tab="nutrition"]');
      var popupImage = mealPopup.querySelector('.meal-popup__image');
      var title = product.title;
      var grams = product.tags.find(function (tag) {
        return tag.indexOf('weight:') > -1;
      });
      var image = product.featured_image;
      var splitDescription = product.content.split('<h6>Nutrition</h6>');
      var description = splitDescription[0];
      var nutrition = splitDescription[1];
      popupTitle.textContent = title;

      if (grams) {
        popupSubtitle.textContent = "".concat(grams.split(':'), " grams");
      }

      popupDescription.innerHTML = description;
      popupNutrition.style.pointerEvents = 'none';

      if (nutrition) {
        popupNutrition.innerHTML = nutrition;
      } else {
        popupNutrition.innerHTML = '<p>No nutritional information available</p>';
      }

      popupImage.src = image;
      return true;
    };

    var updateProductCounts = function updateProductCounts() {
      mealCards.forEach(function (mealCard) {
        mealCard.classList.remove('meal__card--active');
      });
      totalMealCount = virtualCart.reduce(function (count, meal) {
        return count + meal.count;
      }, 0);

      if (totalMealCount < maxMealCount) {
        disableFormButtons();
      } else {
        enableFormButtons();
      }

      productTypes.forEach(function (mealType) {
        // Find all the products in the collection that have these meal type
        var mealAccordion = accordion.querySelector("[data-meal-type=\"".concat(mealType, "\"]"));
        var meals = virtualCart.filter(function (meal) {
          return meal.type === mealType;
        }); // Reset the meal cards so we can turn them to active or inactive

        if (meals.length) {
          var maxMeals = maxProducts[mealType];
          var mealCount = meals.reduce(function (count, meal) {
            return count + meal.count;
          }, 0); // Find the meal count for that product type and update it.

          mealAccordion.querySelector('.meal__count').innerHTML = "".concat(mealCount, " of ").concat(maxMeals);
          mealAccordion.querySelector('.meal__progress').style.width = "".concat(mealCount / maxMeals * 100, "%"); // Update the meal cards to show the quantity up or down.

          virtualCart.forEach(function (meal) {
            var mealCard = document.querySelector(".meal__items--".concat(meal.type, " .meal__card[data-meal-id=\"").concat(meal.id, "\"]"));

            if (mealCard) {
              mealCard.classList.add('meal__card--active');
              mealCard.querySelector('.meal__quantity').innerHTML = meal.count;
            }
          });

          if (mealCount === maxMeals) {
            mealAccordion.classList.add('accordion__item--completed');
            mealAccordion.querySelectorAll('.meal__button--plus, .meal__button--add').forEach(function (btn) {
              btn.disabled = true;
            });
            mealAccordion.classList.remove('accordion__item--active');

            if (mealAccordion.nextElementSibling) {
              mealAccordion.nextElementSibling.classList.add('accordion__item--active');
            } else if (subscriptionSelector) {
              // We're at the end of the food items so we should focus on the meal selector.
              subscriptionSelector.focus();
            }
          } else {
            mealAccordion.classList.remove('accordion__item--completed');
            mealAccordion.querySelectorAll('.meal__button--plus, .meal__button--add').forEach(function (btn) {
              if ('unavailable' in btn.dataset) return;
              btn.disabled = false;
            });
          }
        } else {
          mealAccordion.querySelector('.meal__count').innerHTML = 0;
          mealAccordion.querySelector('.meal__progress').style.width = '0%';
          mealAccordion.classList.remove('accordion__item--completed');
          mealAccordion.querySelectorAll('.meal__button--plus, .meal__button--add').forEach(function (btn) {
            if ('unavailable' in btn.dataset) return;
            btn.disabled = false;
          });
        }
      });
      return true;
    };

    var enableFormButtons = function enableFormButtons() {
      if (subscriptionInput) {
        var selectedVariantId = parseInt(subscriptionInput.value, 10);

        if (selectedVariantId === 0 || totalMealCount < maxMealCount) {
          return;
        }

        if (addToCartButton) {
          addToCartButton.disabled = false;
        }
      }
    };

    var disableFormButtons = function disableFormButtons() {
      if (addToCartButton) {
        addToCartButton.disabled = true;
      }
    };

    var finishProcessingCart = function finishProcessingCart() {
      addToCartButton.innerHTML = 'Finished...';
      setTimeout(function () {
        addToCartButton.innerHTML = 'Add to Cart';
        disableFormButtons();
        virtualCart = [];
        updateProductCounts();
        window.location = '/cart';
      }, 1000);
      return true;
    };

    if (accordionItems) {
      // Toggle the accordion up or down
      accordionItems.forEach(function (item) {
        item.addEventListener('click', function () {
          if (this.parentNode.classList.contains('accordion__item--active')) {
            // We can't close the one that's already open!
            return;
          }

          try {
            accordion.querySelector('.accordion__item--active').classList.remove('accordion__item--active');
          } catch (e) {// ignore the error.
          }

          this.parentNode.classList.add('accordion__item--active');
        });
      });
    }

    if (mealCards) {
      mealCards.forEach(function (mealCard) {
        var informationButton = mealCard.querySelector('.meal__information');
        var addToBundle = mealCard.querySelector('.meal__button--add');
        var increaseQuantity = mealCard.querySelector('.meal__button--plus');
        var decreaseQuantity = mealCard.querySelector('.meal__button--minus');
        var mealType = mealCard.dataset.mealType;

        if (informationButton) {
          informationButton.addEventListener('click', function () {
            var product = findProduct(this.dataset.mealId);
            var body = document.querySelector('body');
            mealPopup.style.display = 'block';
            body.classList.add('popup--open');
            buildPopup(product);
          });
        }

        increaseQuantity.addEventListener('click', function () {
          var mealId = parseInt(this.dataset.mealId, 10); // Find the id in the virtual cart

          var mealIndex = virtualCart.findIndex(function (meal) {
            return meal.id === mealId && meal.type === mealType;
          });
          virtualCart[mealIndex].count += 1;
          updateProductCounts();
          return true;
        });
        decreaseQuantity.addEventListener('click', function () {
          var mealId = parseInt(this.dataset.mealId, 10);
          var mealIndex = virtualCart.findIndex(function (meal) {
            return meal.id === mealId && meal.type === mealType;
          });
          virtualCart[mealIndex].count -= 1;

          if (virtualCart[mealIndex].count <= 0) {
            // Remove the item from the virtual cart
            virtualCart = virtualCart.filter(function (meal) {
              return meal.id !== mealId;
            });
          }

          updateProductCounts();
        });

        if (addToBundle) {
          addToBundle.addEventListener('click', function (evt) {
            evt.preventDefault();
            var mealProductId = parseInt(this.dataset.mealId, 10);
            var meal = findProduct(mealProductId);
            var mealId = meal.variants[0].id;
            var mealCategory = meal.type;
            var mealIndex = virtualCart.findIndex(function (cartMeal) {
              return cartMeal.id === mealId;
            }); // var mealType = meal

            if (mealIndex > -1) {
              virtualCart[mealIndex].count = virtualCart[mealId].count + 1;
            } else {
              virtualCart.push({
                id: parseInt(mealProductId, 10),
                variantId: mealId,
                type: mealType,
                category: mealCategory,
                price: meal.price,
                title: meal.title,
                count: 1
              });
            }

            updateProductCounts();
          });
        }
      });
    }

    if (mealPopup) {
      var closePopup = mealPopup.querySelector('.meal-popup__close');

      if (closePopup) {
        closePopup.addEventListener('click', function () {
          var body = document.querySelector('body');
          body.classList.remove('popup--open');
          mealPopup.style.display = 'none';
        });
      }

      var popupTabs = mealPopup.querySelectorAll('.meal-popup__tab');

      if (popupTabs) {
        popupTabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var activeTab = mealPopup.querySelector('.meal-popup__tab--active');
            var activeContent = mealPopup.querySelector('.meal-popup__text--active');
            var target = mealPopup.querySelector("[data-tab=\"".concat(this.dataset.target, "\"]"));

            if (activeTab) {
              activeTab.classList.remove('meal-popup__tab--active');
              activeContent.classList.remove('meal-popup__text--active');
            }

            this.classList.add('meal-popup__tab--active');

            if (target) {
              target.classList.add('meal-popup__text--active');
            }
          });
        });
      }
    }

    if (subscriptionInput) {
      subscriptionInput.addEventListener('change', function (event) {
        // We need to find the variant and check the title.
        var selectedId = parseInt(event.target.value, 10);

        if (selectedId === 0) {
          disableFormButtons();
          return;
        }

        enableFormButtons();
      });
    }
    /**
     * Handle the add to cart button click.
     * Add the bundle product and all the individual meals to cart with all relevant line item properties.
     */


    if (addToCartForm) {
      addToCartForm.addEventListener('submit', function (evt) {
        evt.preventDefault();
        var selectedVariant;
        var selectedVariantId = parseInt(subscriptionInput.value, 10);

        if (subscriptionProductData.variants.length > 1) {
          selectedVariant = subscriptionProductData.variants.find(function (variant) {
            return variant.id === selectedVariantId;
          });
        } else {
          var _subscriptionProductD = _slicedToArray(subscriptionProductData.variants, 1);

          selectedVariant = _subscriptionProductD[0];
        }

        var isSubscription = false;
        var subsciptionFrequency = subscriptionData.shipping_interval_frequency;

        if (selectedVariant) {
          if (selectedVariant.public_title === 'One Time Only') {
            // This is the one time only subscription we don't need to add the subscription information to the products
            isSubscription = false;
          } else if (selectedVariant.public_title === 'Weekly') {
            // This is the subscription product we need to add the subscription id and information to the products.
            isSubscription = true;
            subsciptionFrequency = 7;
          } else if (selectedVariant.public_title === 'Monthly') {
            isSubscription = true;
            subsciptionFrequency = 30;
          }
        }

        var bundleId = getUniqueBundleID();
        var productTitle = addToCartForm.getAttribute('data-product-title');
        var bundleProduct = {
          id: selectedVariantId,
          quantity: 1,
          properties: _objectSpread({
            _bundle_product: productTitle,
            _bundle_id: bundleId,
            _is_bundle: true
          }, isSubscription && {
            shipping_interval_frequency: subsciptionFrequency,
            shipping_interval_unit_type: subscriptionData.shipping_interval_unit_type,
            subscription_id: subscriptionData.subscription_id
          })
        };
        var bundleMealItems = virtualCart.map(function (item) {
          return {
            quantity: item.count,
            id: item.variantId,
            properties: _objectSpread({
              _type: item.type,
              _category: item.category,
              _title: item.title,
              _bundle_id: bundleId
            }, isSubscription && {
              recurring_price: 0,
              shipping_interval_frequency: subsciptionFrequency,
              shipping_interval_unit_type: subscriptionData.shipping_interval_unit_type,
              subscription_id: subscriptionData.subscription_id
            })
          };
        });
        var productsToAdd = [].concat(_toConsumableArray(bundleMealItems), [bundleProduct]);

        if (virtualCart.length > 0) {
          addToCartButton.innerHTML = 'Adding meals...';
          axios({
            method: 'POST',
            url: '/cart/add.js',
            data: {
              items: productsToAdd
            }
          }).then(function () {
            finishProcessingCart();
          }).catch(function (error) {
            console.log('Error: ', error);
          }); // processVirtualCart(lineItemProperties);
        }
      });

      var getUniqueBundleID = function getUniqueBundleID() {
        var CHARACTERS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';

        var getChar = function getChar(list) {
          return list[Math.floor(Math.random() * (list.length - 1))];
        };

        var id = '';

        while (id.length < 8) {
          id += getChar(CHARACTERS);
        }

        return id;
      };
    }
  }).catch(function (error) {
    console.log('Error: ', error);
  });
});